/**
 * ep-observer.js — Section fade-up via IntersectionObserver.
 * Adds .ep-visible to .ep-fade-up elements when they enter the viewport.
 * CSS in everpaw-tokens.css handles the actual transition.
 * Respects prefers-reduced-motion via CSS (no JS check needed — CSS handles it).
 */
(function () {
  if (!('IntersectionObserver' in window)) {
    // Fallback: just show everything immediately
    document.querySelectorAll('.ep-fade-up').forEach(function (el) {
      el.classList.add('ep-visible');
    });
    return;
  }

  const io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ep-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -32px 0px' }
  );

  function observe() {
    document.querySelectorAll('.ep-fade-up:not(.ep-visible)').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
